import { Accessibility } from 'app/graphql/__generated__/types/contento';
import CONTENTO_TYPES from '../domain/ContentoTypes';
import VideoTypes from '../domain/VideoTypes';
import get from './get';
import AccessServiceTypes from '../domain/AccessServiceTypes';

export const transformContentType = (type: CONTENTO_TYPES): VideoTypes => {
    switch (type) {
        case CONTENTO_TYPES.SINGLE:
            return VideoTypes.SINGLE;
        case CONTENTO_TYPES.EPISODE:
        case CONTENTO_TYPES.VARIANT:
            return VideoTypes.EPISODE;
        case CONTENTO_TYPES.TVSERIES:
        case CONTENTO_TYPES.TVSHOW:
            return VideoTypes.TITLE;
        case CONTENTO_TYPES.CLIP:
        case CONTENTO_TYPES.TRAILER:
            return VideoTypes.CLIP;
        default:
            return VideoTypes.TITLE;
    }
};

type Variant = {
    accessibility: Accessibility | AccessServiceTypes;
    videoSvtId?: string;
    svtId?: string;
    urls: {
        svtplay: string;
    };
};

type ContentItem = {
    variants?: Array<Variant>;
    episode?: {
        variants?: Array<Variant>;
    };
    svtId: string;
    videoSvtId: string;
    urls?: {
        svtplay: string;
    };
};

export const getContentUrl = (
    item: ContentItem,
    currentAccessibilityChoiceContento: Accessibility
): string => {
    const accessibilityVariant = (item.variants || item.episode?.variants || []).find(
        (variant) => variant.accessibility === currentAccessibilityChoiceContento
    );

    if (accessibilityVariant?.urls?.svtplay) {
        return accessibilityVariant.urls.svtplay;
    }

    return item?.urls?.svtplay ? item.urls.svtplay : '/sida-saknas';
};

export const getContentSvtId = (
    item: ContentItem,
    currentAccessibilityChoiceContento: AccessServiceTypes
): string => {
    const accessibilityVariant = (item.variants || item.episode?.variants || []).find(
        (variant) => variant.accessibility === currentAccessibilityChoiceContento
    );

    if (accessibilityVariant?.svtId) {
        return accessibilityVariant.svtId;
    }

    return item.svtId;
};

export const getContentoVideoId = (
    item: ContentItem,
    currentAccessibilityChoiceContento: Accessibility
): string => {
    const accessibilityVariant = (item.variants || item.episode?.variants || []).find(
        (variant) => variant.accessibility === currentAccessibilityChoiceContento
    );

    if (accessibilityVariant) {
        return accessibilityVariant.videoSvtId;
    }

    return item.videoSvtId;
};

export type ListTracking = {
    listType: string;
    listId: string;
    episodeDelta?: number;
    seasonDelta?: number;
    playedPercentage?: number;
};

type ListTrackingSelection = {
    analyticsIdentifiers: {
        listType: string;
        listId: string;
    };
};

export const generateListTracking = (selection: ListTrackingSelection): ListTracking => ({
    listType: get(selection, 'analyticsIdentifiers.listType'),
    listId: get(selection, 'analyticsIdentifiers.listId'),
});

export const isProbablyEscenicId = (id: string): boolean => {
    if (id) {
        return String(id).match(/^\d+$/gi) !== null;
    }

    return false;
};
